import React, { useEffect, useState } from "react";
import { Link as DomLink } from "react-router-dom";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import api from "../../../utils/api";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import remarkGfm from "remark-gfm";
import { styled } from "@mui/material/styles";
import LandingFooter from "../../pages/static/LandingFooter";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import qs from "qs";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { constants } from "../../../utils";

const ImageButton = styled("span")(({ theme }) => ({
  position: "relative",
  height: 500,
  [theme.breakpoints.down("sm")]: {
    width: "100% !important", // Overrides inline-style
    height: 100,
  },
}));

const ImageSrc = styled("span")({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: "cover",
  backgroundPosition: "center 40%",
});

const Image = styled("span")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.common.white,
}));

const ImageBackdrop = styled("span")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.black,
  opacity: 0.15,
  transition: theme.transitions.create("opacity"),
}));

export default function DiamondServicesPage(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [Banner, setBanner] = useState();
  const [MeleePurchasing, setMeleePurchasing] = useState();
  const [StoneRemoval, setStoneRemoval] = useState();
  const [StoneFrosting, setStoneFrosting] = useState();
  const [StoneScreening, setStoneScreening] = useState();
  const [StoneSetting, setStoneSetting] = useState();
  const [GreenRectangle, setGreenRectangle] = useState();
  const [FooterIcons, setFooterIcons] = useState();
  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  useEffect(() => {
    //window.scrollTo(0, 0);
    const query = qs.stringify({
      populate: {
        Banner: {
          populate: "*",
        },
        MeleePurchasing: {
          populate: "*",
        },
        StoneRemoval: {
          populate: "*",
        },
        StoneFrosting: {
          populate: "*",
        },
        StoneScreening: {
          populate: "*",
        },
        StoneSetting: {
          populate: "*",
        },
        GreenRectangle: {
          populate: "*",
        },
        FooterIcons: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/diamond-services-page?${query}`).then((response) => {
      setBanner(response.data.data.attributes.Banner.data.attributes);
      setMeleePurchasing(response.data.data.attributes.MeleePurchasing);
      setStoneRemoval(response.data.data.attributes.StoneRemoval);
      setStoneFrosting(response.data.data.attributes.StoneFrosting);
      setStoneScreening(response.data.data.attributes.StoneScreening);
      setStoneSetting(response.data.data.attributes.StoneSetting);
      setGreenRectangle(response.data.data.attributes.GreenRectangle);
      setFooterIcons(response.data.data.attributes.FooterIcons);
      setIsLoaded(true);
    });
  }, []);

  return (
    <>
      {!isLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl" className="careers-text">
          <Mobile>
            <Stack spacing={3} alignItems="center">
              {Banner && (
                <img
                  src={`${frontImageUrl}${Banner.url}`}
                  width="100%"
                  alt="banner"
                />
              )}
              <Divider flexItem />
              <Typography variant="articleTitle">Diamond Services</Typography>
              <Stack spacing={3} alignItems="center">
                {MeleePurchasing && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {MeleePurchasing.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {MeleePurchasing.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <DomLink
                      to={{
                        pathname: "/stone-purchasing-service",
                      }}
                      className="center"
                    >
                      <Button color="primary" variant="contained" size="small">
                        Learn More
                      </Button>
                    </DomLink>
                  </Stack>
                )}
                {MeleePurchasing && (
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/TsrTeE-0imQ"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                )}
              </Stack>
              <Divider flexItem />
              <Stack spacing={3} alignItems="center" sx={{ margin: "5rem" }}>
                {StoneRemoval && (
                  <img
                    src={`${frontImageUrl}${StoneRemoval.image.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {StoneRemoval && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {StoneRemoval.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {StoneRemoval.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <Link
                      href="https://cms.hooverandstrong.com/uploads/Refining_Chain_Custody_Form2_24_23_4f71403791.pdf"
                      className="center"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Submit Stone Removal Lot
                      </Button>
                    </Link>
                  </Stack>
                )}
              </Stack>
              <Divider flexItem />
              <Stack spacing={3} alignItems="center">
                {StoneFrosting && (
                  <img
                    src={`${frontImageUrl}${StoneFrosting.image.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {StoneFrosting && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {StoneFrosting.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {StoneFrosting.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <DomLink
                      to={{
                        pathname: "/lg-screening-cz-frosting-form",
                      }}
                      className="center"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Submit Stones For Frosting
                      </Button>
                    </DomLink>
                  </Stack>
                )}
              </Stack>
              <Divider flexItem />
              <Stack spacing={3} alignItems="center">
                {StoneScreening && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {StoneScreening.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {StoneScreening.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <DomLink
                      to={{
                        pathname: "/lg-screening-cz-frosting-form",
                      }}
                      className="center"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Submit Stones For Screening
                      </Button>
                    </DomLink>
                  </Stack>
                )}
              </Stack>
              <Divider flexItem />
              <Stack spacing={3} alignItems="center">
                {StoneSetting && (
                  <img
                    src={`${frontImageUrl}${StoneSetting.image.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {StoneSetting && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {StoneSetting.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {StoneSetting.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <DomLink
                      to={{
                        pathname: "/melee-diamonds",
                      }}
                      className="center"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Search Our Melee Selection
                      </Button>
                    </DomLink>
                    <DomLink
                      to={{
                        pathname: "/stone-setting-submission-form",
                      }}
                      className="center"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Submit Stones For Setting
                      </Button>
                    </DomLink>
                  </Stack>
                )}
              </Stack>
              <Divider flexItem />
              <Stack spacing={1} alignItems="center" justifyContent="center">
                <Typography variant="articleTitle">Questions?</Typography>
                <DomLink
                  to={{
                    pathname: "/Frequently-Asked-Questions",
                  }}
                  className="center"
                >
                  <Typography
                    variant="diamondTabFont"
                    sx={{
                      textDecoration: "underline",
                    }}
                  >
                    CLICK HERE
                  </Typography>
                </DomLink>
                <Typography variant="diamondTabFont">
                  for our frequently asked questions or contact one of our
                  specialists:
                </Typography>
                <Typography variant="diamondTabFont">
                  auction@hooverandstrong.com
                </Typography>
                <Typography variant="diamondTabFont">
                  1-800-759-9997 ext. 485
                </Typography>
              </Stack>
              <Divider flexItem />
              <Typography variant="mobileGreenRectangle" align="center">
                {GreenRectangle.text}
              </Typography>
              <LandingFooter icons={FooterIcons} />
            </Stack>
          </Mobile>
          <Default>
            <Stack spacing={3} alignItems="center">
              {Banner && (
                <img
                  src={`${frontImageUrl}${Banner.url}`}
                  width="100%"
                  alt="banner"
                />
              )}
              <Typography variant="articleTitle">Diamond Services</Typography>
              <Stack direction="row" spacing={3} alignItems="center">
                {MeleePurchasing && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {MeleePurchasing.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {MeleePurchasing.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <DomLink
                      to={{
                        pathname: "/stone-purchasing-service",
                      }}
                      className="center"
                    >
                      <Button color="primary" variant="contained" size="small">
                        Learn More
                      </Button>
                    </DomLink>
                  </Stack>
                )}
                {MeleePurchasing && (
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/TsrTeE-0imQ"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                )}
              </Stack>
              <Divider flexItem />
              <ImageButton
                style={{
                  width: "100%",
                }}
              >
                <ImageSrc
                  style={{
                    backgroundImage: `url(${frontImageUrl}${StoneRemoval.image.data.attributes.url})`,
                  }}
                />
                <ImageBackdrop className="MuiImageBackdrop-root" />
                <Image>
                  <Stack
                    direction="row"
                    spacing={3}
                    alignItems="center"
                    sx={{ margin: "5rem" }}
                  >
                    {StoneRemoval && (
                      <Stack
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Stack spacing={2}>
                          <Typography
                            variant="diamondTabFont"
                            sx={{ fontWeight: "800" }}
                          >
                            {StoneRemoval.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {StoneRemoval.body}
                            </ReactMarkdown>
                          </Typography>
                        </Stack>
                        <Link
                          href="https://cms.hooverandstrong.com/uploads/Refining_Chain_Custody_Form2_24_23_4f71403791.pdf"
                          className="center"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Button
                            color="primary"
                            variant="contained"
                            size="small"
                            sx={{ width: "30rem" }}
                          >
                            Submit Stone Removal Lot
                          </Button>
                        </Link>
                      </Stack>
                    )}
                  </Stack>
                </Image>
              </ImageButton>
              <Divider flexItem />
              <Stack direction="row" spacing={3} alignItems="center">
                {StoneFrosting && (
                  <img
                    src={`${frontImageUrl}${StoneFrosting.image.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {StoneFrosting && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {StoneFrosting.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {StoneFrosting.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <DomLink
                      to={{
                        pathname: "/lg-screening-cz-frosting-form",
                      }}
                      className="center"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Submit Stones For Frosting
                      </Button>
                    </DomLink>
                  </Stack>
                )}
              </Stack>
              <Divider flexItem />
              <Stack direction="row" spacing={3} alignItems="center">
                {StoneScreening && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {StoneScreening.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {StoneScreening.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <DomLink
                      to={{
                        pathname: "/lg-screening-cz-frosting-form",
                      }}
                      className="center"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Submit Stones For Screening
                      </Button>
                    </DomLink>
                  </Stack>
                )}
              </Stack>
              <Divider flexItem />
              <Stack direction="row" spacing={3} alignItems="center">
                {StoneSetting && (
                  <img
                    src={`${frontImageUrl}${StoneSetting.image.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {StoneSetting && (
                  <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant="diamondTabFont"
                        sx={{ fontWeight: "800" }}
                      >
                        {StoneSetting.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {StoneSetting.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                    <DomLink
                      to={{
                        pathname: "/melee-diamonds",
                      }}
                      className="center"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Search Our Melee Selection
                      </Button>
                    </DomLink>
                    <DomLink
                      to={{
                        pathname: "/stone-setting-submission-form",
                      }}
                      className="center"
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        sx={{ width: "30rem" }}
                      >
                        Submit Stones For Setting
                      </Button>
                    </DomLink>
                  </Stack>
                )}
              </Stack>
              <Divider flexItem />
              <Stack spacing={1} alignItems="center" justifyContent="center">
                <Typography variant="articleTitle">Questions?</Typography>
                <Stack direction="row" spacing={1}>
                  <DomLink
                    to={{
                      pathname: "/Frequently-Asked-Questions",
                    }}
                    className="center"
                  >
                    <Typography
                      variant="diamondTabFont"
                      sx={{
                        textDecoration: "underline",
                      }}
                    >
                      CLICK HERE
                    </Typography>
                  </DomLink>
                  <Typography variant="diamondTabFont">
                    for our frequently asked questions or contact one of our
                    specialists:
                  </Typography>
                </Stack>
                <Typography variant="diamondTabFont">
                  auction@hooverandstrong.com
                </Typography>
                <Typography variant="diamondTabFont">
                  1-800-759-9997 ext. 485
                </Typography>
              </Stack>
              <Divider flexItem />
              <Typography variant="greenRectangle" align="center">
                {GreenRectangle.text}
              </Typography>
              <LandingFooter icons={FooterIcons} />
            </Stack>
          </Default>
        </Container>
      )}
    </>
  );
}
